export default {
  initialColorMode: "dark",
  useSystemColorMode: false,
};
